<div class="image-container d-flex align-items-center justify-content-center {{backgroundClass}}">
  @if (!!imageUrl) {
    <img [src]="imageUrl" [alt]="imageAlt" class="mh-100 mw-100 img-fluid">
  }
</div>
